import { Roles } from './constants';

export const isSuperAdmin = (roles: string[] = []) => {
  return roles.includes(Roles.SUPER_ADMIN);
};
